import { useEffect, useState } from 'react';

/** Часы для подписей времени: пока главная открыта, время записей пересчитывается раз в минуту (§ 22.4). */
export function useNow(intervalMs = 60_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(timer);
  }, [intervalMs]);
  return now;
}
